import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@utils/api";
import { dashboardQKeys } from "@hooks/queries/dashboard/queryKeys";
import { notifications } from "@mantine/notifications";

export const useSyncPayoutStatus = () => {
  const queryClient = useQueryClient();

  const { mutate: syncPayoutStatus, isLoading: isSyncing } = useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post(`payouts/${id}/sync`);
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Status Synced",
        message: "Payout status has been successfully synchronized with JoonaPay.",
        color: "green",
      });
      // Invalidate the payouts table to show the updated status
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payouts(),
      });
      queryClient.invalidateQueries({
        queryKey: dashboardQKeys.payoutSummary(),
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Sync Failed",
        message: error?.response?.data?.detail || "Failed to synchronize status with JoonaPay.",
        color: "red",
      });
    },
  });

  return { syncPayoutStatus, isSyncing };
};
